enum ETextType {
	h1 = 'h1',
	h2 = 'h2',
	h3 = 'h3',
	h4 = 'h4',
	h5 = 'h5',
	h6 = 'h6',
	p = 'p',
	link = 'link',
	span = 'span',
	externalLink = 'externalLink'
}

enum ETextAlign {
	left = 'left',
	right = 'right',
	center = 'center',
	justify = 'justify'
}

enum ETextDecoration {
	underline = 'underline',
	underlineDotted = 'underline dotted',
	underlineDashed = 'underline dashed',
	underlineWavy = 'underline wavy',
	underlineDouble = 'underline double',
	underlineOverline = 'underline overline',
	underlineOverlineDotted = 'underline overline dotted',
	underlineOverlineDashed = 'underline overline dashed',
	underlineOverlineWavy = 'underline overline wavy',
	underlineOverlineDouble = 'underline overline double',
	overline = 'overline',
	overlineDotted = 'overline dotted',
	overlineDashed = 'overline dashed',
	overlineWavy = 'overline wavy',
	overlineDouble = 'overline double',
	lineThrough = 'line-through',
	lineThroughDotted = 'line-through dotted',
	lineThroughDashed = 'line-through dashed',
	lineThroughWavy = 'line-through wavy',
	lineThroughDouble = 'line-through double',
	lineThroughOverline = 'line-through overline',
	lineThroughOverlineDotted = 'line-through overline dotted',
	lineThroughOverlineDashed = 'line-through overline dashed',
	lineThroughOverlineWavy = 'line-through overline wavy',
	lineThroughOverlineDouble = 'line-through overline double',
	none = 'none'
}

enum ETextColumnFill {
	auto = 'auto',
	balance = 'balance'
}

enum ETextTransform {
	unset = 'unset',
	uppercase = 'uppercase',
	lowercase = 'lowercase',
	capitalize = 'capitalize'
}

enum EFontWeight {
	regular = '400',
	bold = '900'
}

enum EFontFamily {
	cinzel = 'Cinzel',
	lato = 'Lato',
	courierPrime = 'Courier Prime'
}

enum EFontStyle {
	normal = 'normal',
	italic = 'italic'
}

enum EWhiteSpace {
	normal = 'normal',
	nowrap = 'nowrap',
	pre = 'pre',
	preLine = 'pre-line',
	preWrap = 'pre-wrap',
	inherit = 'inherit',
	initial = 'initial',
	unset = 'unset'
}

export {
	ETextType,
	ETextAlign,
	ETextDecoration,
	ETextColumnFill,
	ETextTransform,
	EFontWeight,
	EFontFamily,
	EFontStyle,
	EWhiteSpace
};
